// Mvv ->  mision vision valores
class AboutUsMvvReadDto {
  public id: number;
  public mision: string;
  public vision: string;
  public values: string;
}

export default AboutUsMvvReadDto;
